import { useSubmittedToursFilterDrawer } from '../hooks/useSumbittedToursFilterDrawer'
import { HiArrowLeft } from 'react-icons/hi'

import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  IconButton,
} from '@chakra-ui/react'

import {
  Button,
  DateSelect,
  FormAccordionWrapper,
  FormMultiSelectControl,
} from '@/components/ui'
import { submittedAtIntervalOptions } from '@/utils/filterDrawers'

interface IProps {
  isOpen: boolean
  onClose: () => void
}

export const SubmittedToursFilterDrawer = ({ isOpen, onClose }: IProps) => {
  const {
    guardTourStatusOptions,
    isFacilitiesLoading,
    isGuardDataLoading,
    onSubmit,
    onClearFilters,
    submittedAtFilterCount,
    control,
    handleSubmit,
    facilityIdsFilterValue,
    guardIdsFilterValue,
    submittedAtFilterValue,
    statusFilterValue,
    facilityOptions,
    guardOptions,
    facilitySearchValue,
    setFacilitySearchValue,
    guardSearchValue,
    setGuardSearchValue,
  } = useSubmittedToursFilterDrawer({ onClose })

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement='right' size='sm'>
      <DrawerOverlay data-testid='submittedToursFilterDrawer:overlay' />
      <DrawerContent>
        <DrawerHeader
          alignItems='center'
          borderBottomWidth='1px'
          borderColor='#D5DCE4'
          d='flex'
          minH='65px'
          px='5'
          py='0'
        >
          <HStack spacing='3'>
            <IconButton
              aria-label='Back button'
              borderRadius='4px'
              data-testid='submittedToursPage_filterDrawer_backButton'
              h='30px'
              icon={<HiArrowLeft size={18} />}
              minWidth='30px'
              onClick={onClose}
              variant='ghost'
              w='30px'
            />
            <Box fontSize='20px' fontWeight='bold' letterSpacing='-0.53px'>
              Filter Guard Tours
            </Box>
          </HStack>
        </DrawerHeader>
        <DrawerBody>
          <Box mb='3'>
            <FormMultiSelectControl
              control={control}
              defaultValue={
                facilityIdsFilterValue?.length ? facilityIdsFilterValue : null
              }
              id='facilityName'
              isLoading={isFacilitiesLoading}
              label='Facility Name'
              labelStyle={{ cursor: 'inherit' }}
              onSearchChange={setFacilitySearchValue}
              options={facilityOptions}
              placeholder='Select Facility(-ies)'
              searchValue={facilitySearchValue}
            />
          </Box>
          <Box mb='3'>
            <FormMultiSelectControl
              control={control}
              defaultValue={
                guardIdsFilterValue?.length ? guardIdsFilterValue : null
              }
              id='guardName'
              isLoading={isGuardDataLoading}
              label='Guard Name'
              labelStyle={{ cursor: 'inherit' }}
              onSearchChange={setGuardSearchValue}
              options={guardOptions}
              placeholder='Select Guard(s)'
              searchValue={guardSearchValue}
            />
          </Box>
          <Box mb={3}>
            <FormMultiSelectControl
              control={control}
              defaultValue={statusFilterValue || null}
              id='status'
              label='Status'
              labelStyle={{ cursor: 'inherit' }}
              options={guardTourStatusOptions}
              placeholder='Select Status(-es)'
            />
          </Box>
          <Box mb='3'>
            <FormAccordionWrapper
              label='Submitted At'
              labelStyle={{ cursor: 'inherit' }}
              numberSelected={submittedAtFilterCount}
            >
              <DateSelect
                control={control}
                defaultValue={submittedAtFilterValue || null}
                id='submittedAt'
                options={submittedAtIntervalOptions}
              />
            </FormAccordionWrapper>
          </Box>
        </DrawerBody>
        <DrawerFooter borderColor='#D5DCE4' borderTopWidth='1px'>
          <HStack spacing='5' width='full'>
            <Button
              data-testid='submittedToursPage_filter_clearButton'
              isFullWidth
              onClick={onClearFilters}
              variant='secondary'
            >
              Clear All
            </Button>
            <Button
              data-testid='submittedToursPage_filter_applyButton'
              isFullWidth
              onClick={handleSubmit(onSubmit)}
            >
              Apply Filters
            </Button>
          </HStack>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}
